import * as React from 'react';
import LinkFooter from './LinkFooter';
import InfoFooter from './InfoFooter';
import { createErrorBoundary, useStaticData } from '@avensia/excite';
import { styled } from '@glitz/react';
import { Newsletter } from './newsletter';
import { useCurrentPageIsCheckoutPage } from 'webapp/pages/checkout/use-current-page-is-checkout-page';
import TrustpilotBlock from 'webapp/blocks/TrustpilotBlock';

export default React.memo(
  createErrorBoundary(function Footer() {
    const footer = useStaticData<NordicNest.Api.FooterApiModel>();
    const isCheckoutPage = useCurrentPageIsCheckoutPage();

    return (
      <Container css={isCheckoutPage && backgroundDecorator}>
        {!isCheckoutPage && footer?.trustpilotFooter && footer?.trustpilotFooter.widgetHtml && (
          <TrustpilotBlock key="TrustpilotBlock" {...footer?.trustpilotFooter} />
        )}
        <Newsletter key="Newsletter" />
        <LinkFooter key="LinkFooter" />
        <InfoFooter key="InfoFooter" />
      </Container>
    );
  }),
);

const Container = styled.div({
  ['content-visibility' as any]: 'auto',
  [' contain-intrinsic-size' as any]: '1100px',
});

const backgroundDecorator = styled({
  backgroundColor: t => t.checkout?.backgroundColor,
});
